import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { FacilityPanelProps } from './FormTypes';
import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NewOrExistingFacility } from '../../models';
import { NewFacilityForm } from './NewForm';
import { ExistingFacilityForm } from './ExistingForm';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  summary: {
    backgroundColor: theme.palette.grey['200'],
    borderBottom: '1px solid rgba(0,0,0,.125)',
  },
  detailsPanel: {
    paddingBottom: theme.spacing(1),
  },
  detailsContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },
  buttonContainer: {
    marginLeft: theme.spacing(1),
  },
}));

export const FacilityPanel: React.FC<FacilityPanelProps> = observer(
  ({ facility, orderId, onFormChange, onRemove }) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [expanded, setExpanded] = useState(true);

    const getTitleText = () => {
      return facility.type === NewOrExistingFacility.NEW ? `New` : `Existing`;
    };

    const onChange = (update, isValid) => {
      onFormChange(update, isValid);
    };

    const onPanelChange = (event: object, expanded: boolean) => {
      setExpanded(expanded);
    };

    const form =
      facility.type === NewOrExistingFacility.NEW ? (
        <NewFacilityForm
          facility={facility}
          orderId={orderId}
          onChange={onChange}
        ></NewFacilityForm>
      ) : (
        <ExistingFacilityForm
          facility={facility}
          orderId={orderId}
          onChange={onChange}
        ></ExistingFacilityForm>
      );

    return (
      <Accordion square expanded={expanded} onChange={onPanelChange}>
        <AccordionSummary
          className={classes.summary}
          aria-controls="panel1d-content"
          id="panel1d-header"
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography>{getTitleText()}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.detailsPanel}>
          <div className={classes.detailsContainer}>
            {form}
            <div className={classes.buttonContainer}>
              <Button color="primary" onClick={onRemove} variant="contained">
                Remove
              </Button>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    );
  },
);
